// Colored avatar based on customer name initial
const COLORS = [
  'bg-blue-500', 'bg-emerald-500', 'bg-violet-500', 'bg-orange-500',
  'bg-pink-500', 'bg-teal-500', 'bg-red-500', 'bg-amber-500',
  'bg-cyan-500', 'bg-indigo-500',
];

export default function CustomerAvatar({ name = '', size = 'md' }) {
  const initial = name?.trim()?.charAt(0) || '؟';
  const colorIndex = name.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % COLORS.length;
  const bg = COLORS[colorIndex];

  const sizeClass = {
    sm: 'w-9 h-9 text-sm',
    md: 'w-12 h-12 text-lg',
    lg: 'w-16 h-16 text-2xl',
    xl: 'w-20 h-20 text-3xl',
  }[size] || 'w-12 h-12 text-lg';

  return (
    <div className={`${sizeClass} ${bg} rounded-2xl flex items-center justify-center flex-shrink-0 text-white font-bold`}>
      {initial}
    </div>
  );
}